import _ from 'underscore';
import 'bootstrap';
import { DeterministicView } from '@bingads-webui/deterministic-view';
import { allMetrics as defaultMetrics } from '@bingads-webui-campaign/overview-cards-common';
import defaultTemplate from './template.pug';
import defaultButtonTemplate from './button-template.pug';
import defaultDropdownMenuTemplate from './dropdown-menu-template.pug';
import { getDeterministicTooltipView } from './info-tooltip';

export class MetricPicker extends DeterministicView {
  constructor(options) {
    super(_.extend({}, options, { renderInSync: true }));
  }

  initialize({
    template = defaultTemplate,
    buttonTemplate = defaultButtonTemplate,
    buttonTemplateParams = {},
    dropdownMenuTemplate = defaultDropdownMenuTemplate,
    metric,
    metrics,
    leftAlign,
    metricFormatter,
    s$i18n,
    i18n,
    accountsMode,
    deps,
  } = {}) {
    this.template = template;
    this.buttonTemplate = buttonTemplate;
    this.buttonTemplateParams = buttonTemplateParams;
    this.dropdownMenuTemplate = dropdownMenuTemplate;
    this.leftAlign = leftAlign;
    this.metricFormatter = metricFormatter;
    this.s$i18n = s$i18n;
    this.i18n = i18n;
    this.accountsMode = accountsMode;
    this.deps = deps || {};
    this.setState({
      metric,
      metrics,
    });
  }

  get events() {
    return {
      'click .metric-picker': (e) => {
        // if the event was triggered from dropdown menu, ignore it
        if (e.target.classList.contains('dropdown-menu')) {
          e.stopPropagation();
          e.preventDefault();
          return;
        }
        const toggleEl = this.$('.dropdown-toggle')[0];

        if (toggleEl === e.target || toggleEl.contains(e.target)) {
          return;
        }

        this.trigger('pick', {
          metric: this.getState().metric,
        });
      },
      'click .dropdown-menu li': (e) => {
        e.stopPropagation();
        e.preventDefault();
        const { metric } = e.currentTarget.dataset;

        this.setState({
          metric,
        });

        this.trigger('pick', {
          metric: this.getState().metric,
        });

        this.SetUpContentForGlobalA11yAnnounceArea(metric);
      },
    };
  }

  renderTrunk() {
    const {
      performanceMetric = '',
      metric,
      metrics = defaultMetrics(this.deps.config && this.deps.config.get('Permissions'), this.accountsMode),
      hideCurrency,
    } = this.getState();

    this.$el.html(this.template({
      metric,
    }));

    const metricValue = metric ? this.metricFormatter.formatMetric(
      metric,
      performanceMetric || 0,
      { hideCurrency }
    ) : '';
    const addInfo = metricValue === '-';

    if (addInfo) {
      const tooltipView = getDeterministicTooltipView(this.i18n.getString('Dashboard_CurrencyMetric_Info_Tooltip'));

      this.setChild('info-tooltip', tooltipView);
    }

    this.$('.metric-picker').append(this.buttonTemplate({
      s$i18n: this.s$i18n,
      metricValue,
      metric,
      performanceMetric,
      i18n: this.i18n,
      addInfo,
      ...this.buttonTemplateParams,
    }));

    this.$('.metric-picker').append(this.dropdownMenuTemplate({
      s$i18n: this.s$i18n,
      metrics,
      leftAlign: this.leftAlign,
    }));

    return this;
  }

  SetUpContentForGlobalA11yAnnounceArea(metricName) {
    const a11yAnnounceArea = document.querySelector('#a11yAnnounceArea');
    if (a11yAnnounceArea) {
      a11yAnnounceArea.textContent = this.i18n.getString('Dashboard_Graph_MetricsName_Updated_A11y_Info').replace('{{metricsName}}', this.s$i18n.property('PerformanceMetrics', metricName));
      setTimeout(() => {
        a11yAnnounceArea.textContent = '';
      }, 0);
    }
  }
}
